<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-container
          v-scroll="verificarPosicionY"
          :pa-0="$vuetify.breakpoint.lgAndDown"
          class="py-0"
        >
          <!-- <v-card class="elevation-15 pa-5"> -->
          <Head />
          <br />
          <Menu />

          <v-content class="app_central">
            <v-container
              grid-list-lg
              text-xs-center
              :pa-0="$vuetify.breakpoint.mdAndDown"
            >
              <v-snackbar
                v-model="snackbar"
                multi-line
                right
                bottom
                :color="errorColor"
                >{{ error }}</v-snackbar
              >
              <v-slide-x-transition>
                <router-view></router-view>
              </v-slide-x-transition>
            </v-container>
          </v-content>
          <v-fab-transition>
            <v-btn
              v-show="boton_top"
              dark
              fab
              fixed
              bottom
              right
              color="primary lighten-4"
              @click="regresarPosicion(0)"
              small
            >
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
          </v-fab-transition>

          <Footer />
          <!--  </v-card>  -->
        </v-container>
      </v-content>

      <v-dialog v-model="comunicado" width="900px" persistent>
        <v-card class>
          <v-card-title class="headline py-0 my-3 mx-0 px-10">
           
            <v-spacer></v-spacer>
        
          </v-card-title>
          <v-card-text class="pa-3 ma-0.5"> 
              <v-img
                      :src="require('@/assets/comunicado_renovacion.jpeg')"
                      aspect-ratio="1.9"
                      contain
                      ></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
           
              <v-btn color="#33A2FF" 
              flat 
              @click="comunicado = false">
              <v-icon class="pr-1">close</v-icon> Cerrar
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="comunicado_dos" width="900px" persistent>
        <v-card class>
          <v-card-title class="headline py-0 my-3 mx-0 px-0">
            <v-spacer></v-spacer>
        
          </v-card-title>
          <v-card-text class="pa-3 ma-0.5"> 
              <v-img
                      :src="require('@/assets/convocatoriaONU_PRC0034051.jpg')"
                      aspect-ratio="1.9"
                      contain
                      ></v-img>             
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
                    <v-btn
              color="#341f4e"
              dark
              class="caption"
              @click.stop="accionComunicado_dos"
            >
              <v-icon class="pr-1">edit</v-icon> Postular</v-btn> 
              <v-btn color="#341f4e" 
              flat 
              @click="comunicado_dos = false">
              <v-icon class="pr-1">close</v-icon> Cerrar
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-btn
        v-if="whatsapp"
        fixed
        dark
        fab
        bottom
        right
        class="button-whatsapp"
        @click="openChat"
      >
        <img :src="require('@/assets/whatsapp-logo.png')" width="35px" />
      </v-btn>
      <app-confirm />
    </v-app>
  </div>
  
</template>
<script>
import Head from "@/components/Head";
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";
import { mapState } from "vuex";
import AppConfirm from "@/common/plugins/Modal/Confirm.vue";
export default {
  name: "app",
  components: {
    Head,
    Menu,
    Footer,
    AppConfirm
  },
  data() {
    
    return {
      comunicado: true,
      comunicado_dos: false,
      whatsapp:  this.$store.state.urlWhatsapp
    };
  },
  mounted: function() {
    this.obtenerDatosIniciales();
  },
 
  watch: {
    error(value) {
      if (value) {
        this.snackbar = true;
      }
    },
    snackbar(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  },
  methods: {
    obtenerDatosIniciales() {
      if (
        this.$store.state.noticias == null ||
        this.$store.state.normativas == null ||
        this.$store.state.cursos == null ||
        this.$store.state.juramentos == null
      ) {
        this.$http
          .get(`${this.$apiUrl}publico/pagina`)
          .then(response => {
            this.$store.commit("setNoticias", response.data.data.noticia);
            this.$store.commit("setNormativas", response.data.data.normativa);
            this.$store.commit("setCursos", response.data.data.curso);
            this.$store.commit("setJuramentos", response.data.data.juramento);
            this.$store.commit("setUrlWhatsapp", response.data.data.urlWhatsapp);
            this.whatsapp = response.data.data.urlWhatsapp
            this.$store.commit(
              "setCredenciales",
              response.data.data.credencial
            );
            this.$store.commit("setOficinas", response.data.data.oficinas);
            this.$http.get(`${this.$apiUrl}publico/cantidad`).then(response => {
              this.$store.commit(
                "setCantidadMatriculacion",
                response.data.data.matriculados
              );
              this.$store.commit(
                "setCantidadRuanna",
                response.data.data.ruanna
              );
              this.$store.commit(
                "setCantidadCiudadania",
                response.data.data.ciudadaniaDigital
              );
            });
          })
          .catch(error => {
            this.$store.commit("setErrorColor", "error");
            this.$store.commit(
              "setError",
              "La página tiene errores vuelva a intentarlo mas tarde"
            );
            if (error.response) {
              if (error.response.status == 404) {
                this.$store.commit(
                  "setError",
                  "Error en la peticion al servidor"
                );
              }
            }
          });
      }
    },
    verificarPosicionY(event) {
      if (window.scrollY > 170) {
        this.boton_top = true;
        this.$store.commit("setMenuFixed", true);
      } else {
        this.$store.commit("setMenuFixed", false);
        this.boton_top = false;
      }
    },
    regresarPosicion(value) {
      this.$vuetify.goTo(0);
    },

    accionComunicado() {
      window.open(
        "https://procurement-notices.undp.org/view_negotiation.cfm?nego_id=10486",
        "_blank"
      );
    },
    accionComunicado_dos() {
      window.open(
        "https://procurement-notices.undp.org/view_negotiation.cfm?nego_id=9405",
        "_blank"
      );
    },
    openChat(){
      window.open(this.whatsapp)
      // window.open('https://wa.me/59171521522?text=tengo consulta sobre un tramite que brinda el rpa')
    }
  }
};
</script>
<style>
.v-content__wrap {
  /* background-color: rgba(0,0,0,0.06) !important;*/
}
.app_central {
  background-image: url("./assets/background.png") !important;
  background-repeat: repeat;
  background-size: 50% !important;
}
.border {
  border-left: 8px solid #402d34 !important;
}
.border-primary {
  border-left: 8px solid #534f7f !important;
}

.button-whatsapp{
  top: 84vh !important;
  right: 25px !important;
  background-color: #00e676 !important;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
	0% {
		/* transform: scale(0.95); */
		box-shadow: 0 0 0 0 rgba(23, 197, 125, 0.7);
	}

	70% {
		/* transform: scale(1); */
		box-shadow: 0 0 0 13px rgba(0, 0, 0, 0);
	}

	100% {
		/* transform: scale(0.95); */
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
}

.baner-development{
    float: right;
    top: -9em;
    right: -10em;
    padding: 10px 20px;
    color: white;
    letter-spacing: 2px;
    background: orangered;
    position: absolute;
    text-align: center;
    transform: rotate(45deg);
    width: 320px;
    z-index: 999999999;
}
.baner-development.fixed{
    top: 5em !important;
    right: -4em !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue